<template>
    <el-table
            :max-height="height"
            :data="crafts"
            style="width: 100%"
            ref="craftTable"
            :highlight-current-row="true">

        <el-table-column width="70" fixed="left" label="图片">
            <template slot-scope="scope">
                <image-col :order="scope.row.order"/>
            </template>
        </el-table-column>

        <el-table-column width="150" label="编号">
            <template slot-scope="scope">
                <base-id-col :order="scope.row.order"></base-id-col>
            </template>
        </el-table-column>

        <el-table-column width="100" label="功能">
            <template slot-scope="scope">
                <el-button size="mini" @click="rowClick(scope.row)">编辑/查看</el-button>
            </template>
        </el-table-column>

        <el-table-column width="100"  label="工艺">
            <template slot-scope="scope">
                <current-craft-col :order="scope.row.order" :current-craft="scope.row"></current-craft-col>
            </template>
        </el-table-column>

        <el-table-column prop="status_display" label="状态"></el-table-column>


        <el-table-column label="版房交接">
            <template slot-scope="scope">
                <stereo-col :order="scope.row.order"></stereo-col>
            </template>
        </el-table-column>

        <el-table-column label="面料进度">
            <template slot-scope="scope">
                <apply-main-finish :order="scope.row.order"></apply-main-finish>
            </template>
        </el-table-column>

        <el-table-column width="200" label="面料入库日期">
            <template slot-scope="scope">
                <apply-main-finish-date :order="scope.row.order"/>
            </template>
        </el-table-column>

        <el-table-column label="辅料进度">
            <template slot-scope="scope">
                <apply-sub-finish :order="scope.row.order"></apply-sub-finish>
            </template>
        </el-table-column>

        <el-table-column width="200" label="辅料入库日期">
            <template slot-scope="scope">
                <apply-sub-finish-date :order="scope.row.order"/>
            </template>
        </el-table-column>

        <el-table-column label="加急">
            <template slot-scope="scope">
                <urgent-col :order="scope.row.order"></urgent-col>
            </template>
        </el-table-column>
        <el-table-column prop="order.order_num" label="下单数量"></el-table-column>
        <el-table-column prop="plan_num" label="通知数量"></el-table-column>
        <el-table-column prop="finish_num" label="上报数量"></el-table-column>
        <el-table-column prop="scrap_num" label="报次数量"></el-table-column>


        <el-table-column width="175" label="计划工期">
            <template slot-scope="scope">
                <div style="margin-bottom: 5px" v-if="scope.row.plan_start">
                    <el-tag effect="plain" size="mini">开始 : {{ scope.row.plan_start }}</el-tag>
                </div>
                <div v-if="scope.row.plan_end">
                    <el-tag effect="plain" size="mini">结束 : {{ scope.row.plan_end }}</el-tag>
                </div>
            </template>
        </el-table-column>
        <el-table-column width="175" label="实际工期">
            <template slot-scope="scope">
                <div style="margin-bottom: 5px" v-if="scope.row.actual_start">
                    <el-tag effect="plain" type="success" size="mini">开始 : {{ scope.row.actual_start }}</el-tag>
                </div>
                <div v-if="scope.row.actual_end">
                    <el-tag effect="plain" type="success" size="mini">结束 : {{ scope.row.actual_end }}</el-tag>
                </div>
            </template>
        </el-table-column>

        <el-table-column fixed="right" width="80" label="备注">
            <template slot-scope="scope">
                <remark-col :order="scope.row.order"/>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
    import ImageCol from "../orders/ImageCol"
    import BaseIdCol from "../orders/BaseIdCol"
    import RemarkCol from "../orders/RemarkCol"
    import StereoCol from "../orders/StereoCol"
    import ApplyMainFinish from "../orders/ApplyMainFinish"
    import ApplyMainFinishDate from "../orders/ApplyMainFinishDate"
    import ApplySubFinishDate from "../orders/ApplySubFinishDate"
    import ApplySubFinish from "../orders/ApplySubFinish"
    import UrgentCol from "../orders/UrgentCol"
    import CurrentCraftCol from "../orders/CurrentCraftCol"

    export default {
        name: "CraftTable",
        data() {
            return {
                height: 0,
            }
        },
        props: {
            crafts: {
                type: Array[Object],
                required: true,
            },
            clickCurrentRow: {
                type: Function,
                default: function () {
                    return () => {
                    }
                }
            },
        },
        components: {
            ApplySubFinishDate,
            ApplyMainFinishDate,
            ImageCol, BaseIdCol, RemarkCol,
            StereoCol, ApplyMainFinish, ApplySubFinish,
            UrgentCol, CurrentCraftCol
        },
        methods: {
            setCurrentRow(row) {
                this.$refs.craftTable.setCurrentRow(row)
            },
            rowClick(row) {
                this.setCurrentRow(row)
                this.clickCurrentRow(row)
            },
        },
        created() {
            this.height = document.documentElement.clientHeight - 210
            window.onresize = () => {
                this.height = document.documentElement.clientHeight - 210
            }
        }
    }
</script>

<style scoped>

</style>